import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQualifyNotAllowed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#FF0431"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 8L8 16",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 16L8 8",
			stroke: "white",
			strokeWidth: 1.5
		})
	]
});
export default SvgQualifyNotAllowed;
